export const getSelectedItems = (inStoreProductState) => {
    const { selected, list } = inStoreProductState;
    let newList = [];

    Object.entries(selected).map(([id, value]) => {
        if (value === true) {
            if (typeof list[id] != 'undefined' && list[id]) {
                newList.push(list[id]);
            }
        }
    });

    return newList;
};
export const validateInStoreProductForm = (formData) => {
    let status = true;

    const requiredFields = ['Title', 'Price', 'InternalItemID'];

    requiredFields.map((key) => {
        const fieldStatus =
            typeof formData[key] != 'undefined' && formData[key] != '';
        if (!fieldStatus) {
            status = fieldStatus;
        }
    });

    return status;
};
export const resetInStoreProductForm = () => {
    return {
        ID: 0,
        Title: '',
        Content: '',
        Price: '',
        InternalItemID: '',
    };
};
